module.exports = __webpack_public_path__ + "img/level_spacing.ee44fc61.svg";